<template>
	<div class="alert alert-warning">
		This section is not available in Offline mode. To view these resources please connect to the internet
	</div>
</template>

<script type="text/javascript">

    	export default {
    		name: "PageOfflineAlert",
    	}
</script>


// WEBPACK FOOTER //
// PageOfflineAlert.vue?d3602804